import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "circle-check, check radio, circle, checkbox, check, checkmark, confirm" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M9.99984 6.33464L6.99984 10.0013L5.6665 8.66797M14.3332 8.0013C14.3332 11.4991 11.4976 14.3346 7.99984 14.3346C4.50203 14.3346 1.6665 11.4991 1.6665 8.0013C1.6665 4.5035 4.50203 1.66797 7.99984 1.66797C11.4976 1.66797 14.3332 4.5035 14.3332 8.0013Z",
        stroke: "#7F7F83",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }